export class Parameter {
  [key: string]: any;
  _id?: string;
  _rev?: string;
  type?: string = "parameter";
  standardRange: number = 0;
}
